/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React, { memo } from 'react';
import ContentLoader, { IContentLoaderProps } from 'react-content-loader';

import { skeletonConstants } from '../constants/skeletonConstants';

export const HomePageChartLoader = memo<IContentLoaderProps>(props => (
  <ContentLoader
    height={300}
    width={460}
    backgroundColor={skeletonConstants.backgroundColor}
    foregroundColor={skeletonConstants.foregroundColor}
    style={{
      backgroundColor: skeletonConstants.loaderBackgroundColor,
      borderRadius: '12px',
    }}
    {...props}
  >
    <rect x="20" y="18" rx="6" ry="6" width="87" height="15" />
    <circle cx="123" cy="140" r="90" />
    <rect x="247" y="50" rx="6" ry="6" width="90" height="23" />
    <rect x="247" y="103" rx="6" ry="6" width="90" height="23" />
    <rect x="247" y="156" rx="6" ry="6" width="90" height="23" />
    <rect x="247" y="209" rx="6" ry="6" width="90" height="23" />
  </ContentLoader>
));
